var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalLinkButton',{staticClass:"ta-auction-viewing-information-link",attrs:{"title":_vm.$t('Viewing Information'),"content":_vm.viewingInfo}})}
var staticRenderFns = []

export { render, staticRenderFns }